export default "__VITE_ASSET__DVclbltF__"